import _ from 'lodash';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import { initDycolor } from '~';
import { mapGetters, mapActions, mapState } from 'vuex';

initDycolor('auto-publish-box', require(`${process.env.DYCOLOR_REQUIRE}./AutoPublishBox.scss`)); // eslint-disable-line

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'box-widget': BoxWidget,
  },
  data() {
    return {
      loading: false,
      localValue: 0,
    };
  },
  methods: {
    ...mapActions('campaign', ['setAutoPublish']),
    toggleAutoPublish(value) {
      this.loading = true;

      this.setAutoPublish(value)
        .then(() => {
          this.loading = false;
          this.$toast.success({ message: this.$t('pos.campaign.autopublish-updated') });
        }).catch(error => {
          this.loading = false;
          this.$toast.error({ message: error });
        });
    },
  },
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    ...mapState('genericConfig', ['config']),
    options() {
      return _.map([0, 1], value => ({ value, text: this.$t('fn.complex.enabled-disabled', { value }) }));
    },
  },
  mounted() {
    this.localValue = this.campaign.autopublish;
  },
};



// WEBPACK FOOTER //
// ./src/components/auto-publish-box/AutoPublishBox.js